/**
 * Generate a memorable but strong-ish initial password for a new user.
 * Format: word-XXX-word (e.g. "rapid-472-stone").
 *
 * Length 13-15 chars (well above the 8-char min). Admin tells the user
 * out-of-band; user changes it on first login (must_change_password=true).
 */
const WORDS = [
  'rapid', 'stone', 'cedar', 'maple', 'sandy', 'cloud', 'mango', 'olive',
  'cobalt', 'amber', 'coral', 'plum', 'wheat', 'lemon', 'birch', 'jade',
  'nova', 'pearl', 'opal', 'frost', 'echo', 'lotus', 'flint', 'mint',
];

export function generatePassword(): string {
  const w1 = pick(WORDS);
  const w2 = pick(WORDS);
  const n = Math.floor(Math.random() * 900 + 100);
  return `${w1}-${n}-${w2}`;
}

function pick<T>(arr: T[]): T {
  const idx = Math.floor(Math.random() * arr.length);
  return arr[idx]!;
}
